const BookmarkIcon = ({ filled = false, width = '20', height = '24' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="mingcute:bookmark-line">
        <g id="Group">
          {filled ? (
            <path
              id="Vector"
              d={`M3.33203 4.4668C3.33203 3.80376 3.59542 3.16787 4.06426 2.69903C4.53311 2.23019 
          5.16899 1.9668 5.83203 1.9668H14.1654C14.8284 1.9668 15.4643 2.23019 15.9331 2.69903C16.402 3.16787 16.6654 
          3.80376 16.6654 4.4668V17.8235C16.6654 18.8401 15.5154 19.4318 14.6887 18.841L9.9987 15.491L5.3087 
          18.841C4.4812 19.4326 3.33203 18.841 3.33203 17.8243V4.4668Z`}
            />
          ) : (
            <path
              id="Vector"
              fillRule="evenodd"
              clipRule="evenodd"
              d={`M3.3335 4.16667C3.3335 3.50363 3.59689 2.86775 4.06573 2.3989C4.53457 1.93006 5.17045 1.66667 5.8335
             1.66667H14.1668C14.8299 1.66667 15.4658 1.93006 15.9346 2.3989C16.4034 2.86775 16.6668 3.50363 16.6668
              4.16667V17.5233C16.6668 18.54 15.5168 19.1317 14.6902 18.5408L10.0002 15.1908L5.31016 18.5408C4.48266
               19.1325 3.3335 18.5408 3.3335 17.5242V4.16667ZM5.8335 3.33334C5.61248 3.33334 5.40052 3.42114 5.24424
                3.57742C5.08796 3.7337 5.00016 3.94566 5.00016 4.16667V16.7142L9.2735 13.6617C9.48552 13.5102 9.73958
                 13.4288 10.0002 13.4288C10.2607 13.4288 10.5148 13.5102 10.7268 13.6617L15.0002
                  16.7142V4.16667C15.0002 3.94566 14.9124 3.7337 14.7561 3.57742C14.5998 3.42114 14.3878 3.33334
                   14.1668 3.33334H5.8335Z`}
            />
          )}
        </g>
      </g>
    </svg>
  );
};

export default BookmarkIcon;
